export enum ChatProperties {
    AssistantId = '440307f4-065f-4db9-aa45-bb079afaa203',
}
